import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';
import { Button } from '../ui/button';
import type { TemplateAlertType } from '../../services/api/departmentPermissionService';

interface TemplateAlertBannerProps {
    alertType: TemplateAlertType;
    roleName: string;
    onReview: () => void;
    actionLabel?: string;
}

export default function TemplateAlertBanner({
    alertType,
    roleName,
    onReview,
    actionLabel,
}: TemplateAlertBannerProps) {
    const { t } = useTranslation();
    if (!alertType) return null;

    const messageKey = 'facilities.departmentRoles.alerts.templateUpdated';

    return (
        <div className="flex items-center gap-2.5 rounded-lg border border-white/10 bg-white/[0.04] px-3 py-2">
            <Info className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
            <span className="flex-1 text-xs text-foreground">
                {t(messageKey, { role: roleName })}
            </span>
            <Button variant="outline" size="sm" className="h-6 text-xs" onClick={onReview}>
                {actionLabel ?? t('facilities.departmentRoles.alerts.review')}
            </Button>
        </div>
    );
}
